import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { withActionsExecutor, ActionsExecutorPropsType, Action, ActionError } from "components/actions";

import Loading from "common/components/controls/Loading";
import Error from "common/components/controls/Error";

import DivBox from "common/components/controls/DivBox";
import DetailGrid, { DetailGridItem } from "common/components/controls/DetailGrid";

import { Prestup, GetPrestup as apiGetPrestup } from "common/api/Evidence/Clenove/Prestupy";
//import apiOznameniPrestupu, { OznData } from "common/api/SendEmailNotifications/OznameniPrestupu";

//import PrestupyUtils from "common/utils/PrestupyUtils";


import View from "./detail-prestupu/View";

interface State {
    loading: boolean;
    hasError: boolean;
    error?: string;
    prestup?: Prestup;
}

export interface DetailPrestupuProps {
    backUrl?: string;
    backTitle?: string;
    prestupId: number;
    clenId: number;
}

type Props = State & DetailPrestupuProps & ActionsExecutorPropsType;

const initialState: State = {
    loading: true,
    hasError: false,
}

class DetailPrestupu extends React.PureComponent<Props> {

    load = () => {
        const { executeAction, updateState, prestupId } = this.props;
        const action = apiGetPrestup(prestupId)
            .onSuccess(d => {
                updateState({ loading: false, prestup: d });
            })
            .onError(e => {
                const errMessage = e.errorData && e.errorData.notFound ? `Přestup s ID ${prestupId} nebyl nalezen` : e.message;
                updateState({ loading: false, hasError: true, error: errMessage });
            });

        executeAction(action, { loading: true, hasError: false });
    }

    setPrestup = (prestup: Prestup) => {
        this.props.updateState({ loading: false, prestup: prestup });
    }

    componentWillMount() {
        this.load();
    }

    render() {
        const { loading, hasError, error, prestup, clenId } = this.props;

        return loading
            ? <Loading loading={loading} color="primary" />
            : hasError
                ? <Error>{error}</Error>
                : <View prestup={prestup} setPrestup={this.setPrestup} clenId={clenId} />;
    }
}

export default withActionsExecutor<DetailPrestupuProps, State>(initialState, DetailPrestupu);